import React, { useContext } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import LangSelect from './lang-select';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #000;
  height: 48px;
  .wrapper {
    justify-content: flex-end;
  }
  @media (max-width: 789px) {
    display: none;
  }
  a {
    color: #fff;
    align-items: center;
    text-decoration: none;
    font-size: 13px;
    margin-left: 60px;
    display: flex;
    transition: all 0.3s;
    &:hover {
      color: #D2AE82;
    }
    &:first-child {
      margin-left: 0;
    }
    @media (max-width: 980px) {
      margin-left: 30px;
    }
    i {
      background-size: contain;
      height: 24px;
      width: 24px;
      display: inline-block;
      margin-right: 6px;
    }
  }
`

const OndeEncontrarIcon = styled.i`
  background: url(/images/streamline-icon-earth-pin-2@48x48@2x.png) no-repeat center;
`

const AGuararapesIcon = styled.i`
  background: url(/images/streamline-icon-water-dam@140x140@2x.png) no-repeat center;
`

const ContatoIcon = styled.i`
  background: url(/images/streamline-icon-conversation-chat-text@48x48@2x.png) no-repeat center;
`

const InvestidoresIcon = styled.i`
  background: url(/images/streamline-icon-analytics-graph@140x140@2x.png) no-repeat center;
`

const TopBar = () => {
  const { language } = useContext(LanguageContext);
  let ondeEncontrar = ''
  let contato = ''
  let investidores = ''
  let about = ''
  switch (language) {
    case 'pt-br':
      about = 'A Guararapes';
      ondeEncontrar = 'Onde encontrar';
      contato = 'Contato';
      investidores = 'Investidores';
      break;
    case 'en-us':
      about = 'About us';
      ondeEncontrar = 'Where to find';
      contato = 'Contact';
      investidores = 'Investors';
      break;
    case 'es-es':
      about = 'A Guararapes';
      ondeEncontrar = 'Donde encontrar';
      contato = 'Contacto';
      investidores = 'Inversores';
      break;
    default:
  }
  return (
    <Container>
      <div className="wrapper flex">
        {
          language === 'pt-br' && (
            <Link to="/onde-encontrar">
              <OndeEncontrarIcon />
              { ondeEncontrar }
            </Link>
          )
        }
        {
          language !== 'pt-br' && (
            <Link to="/onde-encontrar/compensados">
              <OndeEncontrarIcon />
              { ondeEncontrar }
            </Link>
          )
        }
        <Link to="/a-guararapes">
          <AGuararapesIcon />
          { about }
        </Link>    
        <Link to="/contato">
          <ContatoIcon />
          { contato }
        </Link>    
        {
          false === true && (
            <Link to="/">
              <InvestidoresIcon />
              { investidores }
            </Link>
          )
        }
        <LangSelect />
      </div>
    </Container>
  )
}

export default TopBar;
